/**
 * Blog Filters - Vanilla JS
 * Handles search and category filtering
 */

import { ready, $, $$, ajax, delegate } from "./utils.js";

ready(() => {
  const categoryDropdown = $(".category-filter-dropdown");
  const searchInput = $("#search-blog");
  const filterForm = $("#filter-blog");
  const responseContainer = $("#response-blog");
  const noResults = $(".no-results");

  // Category filter dropdown change
  if (categoryDropdown && filterForm) {
    categoryDropdown.addEventListener("change", () => {
      filterForm.dispatchEvent(new Event("submit"));
    });
  }

  // Search input filter
  if (searchInput && responseContainer) {
    searchInput.addEventListener("input", function () {
      const searchValue = this.value.toLowerCase();
      const posts = responseContainer.querySelectorAll(".post");
      let visibleCount = 0;

      posts.forEach((post) => {
        const heading = post.querySelector("h3");
        if (heading) {
          const text = heading.textContent.toLowerCase();
          const isMatch = text.indexOf(searchValue) > -1;
          post.style.display = isMatch ? "" : "none";
          if (isMatch) visibleCount++;
        }
      });

      // Toggle no results message
      if (noResults) {
        if (visibleCount === 0) {
          noResults.classList.add("visible");
        } else {
          noResults.classList.remove("visible");
        }
      }
    });
  }

  // Form submission via AJAX
  if (filterForm && responseContainer) {
    filterForm.addEventListener("submit", async function (e) {
      e.preventDefault();

      const formData = new FormData(this);
      const params = new URLSearchParams(formData);

      try {
        const response = await fetch(this.action, {
          method: this.method || "POST",
          body: params,
        });
        const html = await response.text();
        responseContainer.innerHTML = html;

        // Re-apply search filter
        if (searchInput) {
          const searchValue = searchInput.value.toLowerCase();
          if (searchValue) {
            const posts = responseContainer.querySelectorAll(".post");
            posts.forEach((post) => {
              const heading = post.querySelector("h3");
              if (heading) {
                const text = heading.textContent.toLowerCase();
                post.style.display =
                  text.indexOf(searchValue) > -1 ? "" : "none";
              }
            });
          }
        }
      } catch (error) {
        console.error("Blog filter error:", error);
      }
    });
  }

  // Blog archive "Load More" — appends the next page's 3-column block.
  const loadMoreBtn = $("#load-more-blog");

  if (loadMoreBtn && responseContainer) {
    loadMoreBtn.addEventListener("click", async function () {
      const ajaxUrl = this.dataset.ajaxUrl;
      const currentPage = parseInt(this.dataset.page || "1", 10);
      const maxPages = parseInt(this.dataset.maxPages || "1", 10);
      const nextPage = currentPage + 1;

      if (!ajaxUrl || nextPage > maxPages) {
        return;
      }

      const originalLabel = this.textContent;
      this.disabled = true;
      this.textContent = "Loading…";

      try {
        const formData = new FormData();
        formData.append("action", "blog_archive_load_more");
        formData.append("page", String(nextPage));
        if (this.dataset.lang) {
          formData.append("lang", this.dataset.lang);
        }

        const response = await fetch(ajaxUrl, {
          method: "POST",
          body: formData,
        });
        const payload = await response.json();

        if (payload && payload.success && payload.data && payload.data.html) {
          responseContainer.insertAdjacentHTML("beforeend", payload.data.html);
          this.dataset.page = String(nextPage);

          if (!payload.data.has_more || nextPage >= maxPages) {
            this.style.display = "none";
          }
        }
      } catch (error) {
        console.error("Blog archive load more error:", error);
      } finally {
        this.disabled = false;
        this.textContent = originalLabel;
      }
    });
  }

  // Pagination handling
  let postPage = 1;

  // Category dropdown for pagination
  delegate(
    ".post-listing-with-pagination .category-drodown-item .btn-category",
    "click",
    function (e) {
      e.preventDefault();
      const selectedText = this.textContent;
      const selectedDataValue = this.dataset.value;

      const dropdown = $(".post-listing-with-pagination .category-dropdown");
      const dropdownItem = $(
        ".post-listing-with-pagination .category-drodown-item",
      );

      if (dropdown) {
        dropdown.textContent = selectedText;
        dropdown.dataset.value = selectedDataValue;
      }

      if (dropdownItem) {
        dropdownItem.style.display = "none";
      }

      // Update active states
      $$(".post-listing-with-pagination .btn-category").forEach((btn) =>
        btn.classList.remove("active"),
      );
      this.classList.add("active");

      const selectedCategory = this.dataset.value;
      const searchQuery =
        $(".post-listing-with-pagination .post-search-input")?.value || "";
      updatePaginationControls(postPage);
      postFilter(postPage, selectedCategory, searchQuery);
    },
  );

  // Search input for pagination
  const paginationSearch = $(
    ".post-listing-with-pagination .post-search-input",
  );
  if (paginationSearch) {
    paginationSearch.addEventListener("keyup", function () {
      const searchQuery = this.value;
      const activeBtn = $(".post-listing-with-pagination .btn-category.active");
      const selectedCategory = activeBtn ? activeBtn.dataset.value : "";
      postFilter(postPage, selectedCategory, searchQuery);
    });
  }

  // Pagination dots and icons
  delegate(
    ".post-listing-wrapper .pagination .dots, .post-listing-wrapper .pagination .icon-btn",
    "click",
    function (e) {
      e.preventDefault();
      const newPage = parseInt(this.dataset.page);

      const activeBtn = $(".post-listing-with-pagination .btn-category.active");
      const selectedCategory = activeBtn ? activeBtn.dataset.value : "";
      const searchInput = $(".post-listing-with-pagination .post-search-input");
      const searchQuery = searchInput ? searchInput.value : "";

      // Update active state for dots
      $$(".post-listing-wrapper .pagination .dots").forEach((dot) =>
        dot.classList.remove("active"),
      );
      const targetDot = $(
        `.post-listing-wrapper .pagination .dots[data-page="${newPage}"]`,
      );
      if (targetDot) targetDot.classList.add("active");

      postPage = newPage;
      updatePaginationControls(postPage);

      // Smooth scroll to wrapper
      const wrapper = $(".post-listing-wrapper");
      if (wrapper) {
        wrapper.scrollIntoView({ behavior: "smooth", block: "start" });
      }

      // Fetch new posts
      postFilter(postPage, selectedCategory, searchQuery);
    },
  );

  /**
   * Post filter AJAX function
   */
  async function postFilter(postPage, selectedCategory, searchQuery) {
    if (typeof ajax_variable === "undefined") return;

    try {
      const data = await ajax({
        url: ajax_variable.ajax_url,
        method: "POST",
        data: {
          action: "action__post_filters",
          page: postPage,
          category: selectedCategory,
          search: searchQuery,
          security: ajax_variable.post_filters_nonce,
        },
      });

      const postListing = $("#post-listing");
      const paginationWrapper = $(".post-listing-wrapper .pagination-wrapper");

      if (data.response === "success") {
        if (postListing) postListing.innerHTML = data.message;
        if (paginationWrapper) paginationWrapper.innerHTML = data.pagination;
        updatePaginationControls(postPage);
      } else {
        if (postListing) {
          postListing.innerHTML =
            '<div style=\"text-align: center;width: 100%;\">No posts found.</div>';
        }
        if (paginationWrapper) paginationWrapper.innerHTML = "";
      }
    } catch (error) {
      console.error("Post filter error:", error);
    }
  }

  /**
   * Update pagination control states
   */
  function updatePaginationControls(postPage) {
    const pagination = $(".post-listing-wrapper .pagination");
    if (!pagination) return;

    const total = parseInt(pagination.dataset.max || 1);
    const prevPage = $(".post-listing-wrapper .prev-page");
    const nextPage = $(".post-listing-wrapper .next-page");

    if (prevPage) {
      if (postPage === 1) {
        prevPage.classList.add("disabled");
        prevPage.style.pointerEvents = "none";
        prevPage.style.opacity = "0.2";
      } else {
        prevPage.classList.remove("disabled");
        prevPage.style.pointerEvents = "auto";
        prevPage.style.opacity = "1";
      }
    }

    if (nextPage) {
      if (postPage === total) {
        nextPage.classList.add("disabled");
        nextPage.style.pointerEvents = "none";
        nextPage.style.opacity = "0.2";
      } else {
        nextPage.classList.remove("disabled");
        nextPage.style.pointerEvents = "auto";
        nextPage.style.opacity = "1";
      }
    }
  }
});
